import { createI18n } from 'vue-i18n';
import messages from '../messages';

const getLocale = (): string => {
  const storedLocale = localStorage.getItem('locale');
  if (storedLocale) {
    return storedLocale;
  }
  if (navigator.language.includes('tr')) {
    return 'tr';
  }
  return 'en';
};

// Composition mode: `$t` is still injected into templates, and code outside
// components goes through `i18n.global` (where `locale` is a ref).
const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  messages,
  fallbackLocale: 'en',
});

export default i18n;
